export const useDisplayPercentage = (value: number) => {
  return Math.round(value * 100) + '%'
}
